<template>
  <div>
    <section-definition :title="page.title" :extraOptions="page.options" :icon="page.icon"
      :breadcrumbs="page.breadcrumbs" :addNewData="page.addnew" :exportOptions="page.exportOptions"
      @openFilter="filterClick" @refreshPage="refreshThisPage" @addNew="AddNewRule" :style="styleObject">
    </section-definition>
    <loader v-if="page.loading"></loader>
    <v-container v-else fluid grid-list-xl page>
      <v-data-table :headers="headers" :items="timeruleData" class="elevation-1 fixed-layout"
        :pagination.sync="pagination" :total-items="pagecount" :loading="tableLoading" :rows-per-page-items="[10]">
        <template v-slot:no-data style="text-align: center">
          <div style="text-align: center">No Data Available</div>
        </template>
        <template v-slot:items="props">
          <td class="checkEmpty p0">{{ props.item.rule_name }}</td>
          <td class="checkEmpty p0">{{ props.item.description }}</td>
          <td class="checkEmpty p0">
            <template v-if="props.item.active === 'Y'">Active</template>
            <template v-else>Inactive</template>
          </td>




          <td class="text-xs-center checkEmpty p0">
            <v-icon color="blue" small class="mr-4" v-if="page.canedit" @click="editItem(props.item)">edit</v-icon>
            <v-icon color="red" small class="mr-4" v-if="page.candelete" @click="deleteItem(props.item)">delete
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog persistent v-model="DeleteRowdata" max-width="500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title>
            <span class="headline">Delete Time rule Info</span>
          </v-card-title>
        </v-toolbar>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-card-text>{{ deletemsg }}</v-card-text>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="light" flat @click="closedelete()">Cancel</v-btn>
          <v-btn color="primary" @click="savedelete()">Yes, Delete !</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template>
      <v-dialog persistent v-model="page.isAddtimerule" scrollable max-width="500px">
        <v-card>
          <v-toolbar dark color="primary">
            <v-card-title>
              <span class="headline">Create Time rule</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="Timeerule" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="addtimerule.payload.rule_name" required label="Rule Name" type="text"
                    :rules="[
    (v) => !!v || 'Rule Name is required',
    (v) => /^[a-zA-Z0-9_]+$/.test(v) || 'Only letters, numbers, and underscores are allowed'
  ]"></v-text-field>

                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="addtimerule.payload.description" label="Description"
                      type="text"></v-text-field>
                  </v-flex>
                  <v-flex>
                    <h5 style="font-size: 16px; font-weight: 500;">Month</h5>
                    <v-row>
                      <v-col v-for="(month, index) in months" :key="index">
                        <v-div :class="{ 'highlighted': selectedMonths.includes(month) }"
                          @click="toggleMonthSelection(month)" color="primary" class="circle-btn">
                          {{ month }}
                        </v-div>
                      </v-col>
                    </v-row>
                  </v-flex>
                  <v-flex>
                    <h5 style="font-size: 16px; font-weight: 500;">Days</h5>
                    <v-col v-for="(days, index) in days" :key="index">
                      <v-div :class="{
                        'highlighted': selectedweek.includes(days), 'disabled-btn': selecteddates.length > 0
                      }" @click="handleClick(days, selecteddates.length > 0 
                       )" color="primary" class="circle-btn">

                        {{ days }}
                      </v-div>
                    </v-col>
                  </v-flex>
                  <v-flex>
                    <h5 style="font-size: 16px; font-weight: 500;">Dates</h5>
                    <v-row>
                      <v-col v-for="(date, index) in dates" :key="index">
                        <v-div :class="{
                          'highlighteddates': selecteddates.includes(date), 'disabled-btn':  selectedweek.length > 0

                        }" @click="toggleDatesSelection(date, selectedweek.length > 0)"
                          class="date-btn" rounded>
                          {{ date }}
                        </v-div>
                      </v-col>
                    </v-row>
                  </v-flex>
                  <v-flex style="margin-top: 30px;">
                    <!-- From Time -->
                    <v-div style="display: inline-flex; align-items: baseline;">
                      <h5 style="font-size: 16px; font-weight: 500;">From Time</h5>
                      <span
                        style="border: 1px solid #2196F3; padding: 3px; border-radius: 8px; color: #2196F3; margin-left: 10px; cursor: pointer;"
                        @click="opendatefrom(addtimerule.payload.from_time,'create')">
                        {{ addtimerule.payload.from_time }}
                      </span>
                    </v-div>

                    <!-- To Time -->
                    <v-div style="display: inline-flex; align-items: baseline; margin-left: 30px;">
                      <h5 style="font-size: 16px; font-weight: 500;">To Time</h5>
                      <span
                        style="border: 1px solid #2196F3; padding: 3px; border-radius: 8px; color: #2196F3; margin-left: 10px; cursor: pointer;"
                        @click="opendateto( addtimerule.payload.to_time,'create' )">
                        {{ addtimerule.payload.to_time }}

                      </span>
                    </v-div>

                    <!-- Overlay and Time Picker for 'From Time' -->
                    <v-overlay v-if="showfrom_timePicker" :value="showfrom_timePicker" 
                      >
                      <v-dialog v-model="showfrom_timePicker" max-width="286px" style="margin-top: 164px;" persistent>
                        <v-time-picker v-model="addtimerule.payload.from_time" format="24hr" color="primary">
                          <v-spacer></v-spacer>

                          <v-btn text color="primary" @click="closefrom_timePicker('close','add')">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="closefrom_timePicker('ok','add')">
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-overlay>

                    <!-- Overlay and Time Picker for 'To Time' -->
                    <v-overlay v-if="showto_timePicker" :value="showto_timePicker" >
                      <v-dialog v-model="showto_timePicker" max-width="286px" style="margin-top: 164px !important;"
                        persistent>
                        <v-time-picker v-model="addtimerule.payload.to_time" format="24hr" color="primary"
                          :min="getMinTime(addtimerule.payload.from_time)">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="closeto_timePicker('close','add')">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="closeto_timePicker('ok','add')">
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-overlay>
                  </v-flex>
                 
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="modal-footer--sticky">
            <v-spacer></v-spacer>
            <v-btn color="light" flat @click="closeAddtimerule()">Close</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="saveAddtimerule()">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog persistent :value="page.isEdittimerule" scrollable max-width="500px">
        <v-card>
          <v-toolbar dark color="primary">
            <v-card-title>
              <span class="headline">Update Time rule</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="Timeeruleupdate" v-model="editvalid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="edittimerule.rule_name" required label="Rule Name" type="text"
                      :rules="[(v) => !!v || ' Rule Name  is required']" :readonly="true"></v-text-field>

                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="edittimerule.description" label="Description" type="text"></v-text-field>
                  </v-flex>
                  <v-flex>
                    <h5 style="font-size: 16px; font-weight: 500;">Month</h5>
                    <v-row>
                      <v-col v-for="(month, index) in months" :key="index">
                        <v-div :class="{ 'highlighted': selectedMonths.includes(month) }"
                          @click="toggleMonthSelection(month)" color="primary" class="circle-btn">
                          {{ month }}
                        </v-div>
                      </v-col>
                    </v-row>
                  </v-flex>
                  <v-flex>
                    <h5 style="font-size: 16px; font-weight: 500;">Days</h5>
                    <v-col v-for="(days, index) in days" :key="index">
                      <v-div :class="{
                        'highlighted': selectedweek.includes(days), 'disabled-btn': selecteddates.length > 0 
                      }" @click="handleClick(days, selecteddates.length > 0)" color="primary" class="circle-btn">

                        {{ days }}
                      </v-div>
                    </v-col>
                  </v-flex>
                  <v-flex>
                    <h5 style="font-size: 16px; font-weight: 500;">Dates</h5>
                    <v-row>
                      <v-col v-for="(date, index) in dates" :key="index">
                        <v-div :class="{
                          'highlighteddates': selecteddates.includes(date), 'disabled-btn':  selectedweek.length > 0

                        }" @click="toggleDatesSelection(date,  selectedweek.length > 0)"
                          class="date-btn" rounded>
                          {{ date }}
                        </v-div>
                      </v-col>
                    </v-row>
                  </v-flex>
                  <v-flex style="margin-top: 30px;">
                    <!-- From Time -->
                    <v-div style="display: inline-flex; align-items: baseline;">
                      <h5 style="font-size: 16px; font-weight: 500;">From Time</h5>
                      <span
                        style="border: 1px solid #2196F3; padding: 3px; border-radius: 8px; color: #2196F3; margin-left: 10px; cursor: pointer;"
                        @click="opendatefrom( edittimerule.from_time,'edit')">
                        {{ edittimerule.from_time }}
                      </span>
                    </v-div>

                    <!-- To Time -->
                    <v-div style="display: inline-flex; align-items: baseline; margin-left: 30px;">
                      <h5 style="font-size: 16px; font-weight: 500;">To Time</h5>
                      <span
                        style="border: 1px solid #2196F3; padding: 3px; border-radius: 8px; color: #2196F3; margin-left: 10px; cursor: pointer;"
                        @click="opendateto(edittimerule.to_time,'edit' )">
                        {{ edittimerule.to_time }}

                      </span>
                    </v-div>

                    <!-- Overlay and Time Picker for 'From Time' -->
                    <v-overlay v-if="showfrom_timePickeredit" :value="showfrom_timePickeredit"
                     >
                      <v-dialog v-model="showfrom_timePickeredit" max-width="286px"  persistent>
                        <v-time-picker v-model="edittimerule.from_time" format="24hr" color="primary">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="closefrom_timePicker('close','edit')">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="closefrom_timePicker('ok','edit')">
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-overlay>

                    <!-- Overlay and Time Picker for 'To Time' -->
                    <v-overlay v-if="showto_timePickeredit" :value="showto_timePickeredit" >
                      <v-dialog v-model="showto_timePickeredit" max-width="286px" 
                        persistent>
                        <v-time-picker v-model="edittimerule.to_time" format="24hr" color="primary"
                          :min="getMinTime(edittimerule.from_time)">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="closeto_timePicker('close','edit')">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="closeto_timePicker('ok','edit')">
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-overlay>
                  </v-flex>
                  <v-flex>
                    <v-select :items="status" label="Status"
                      v-model="edittimerule.active" item-text="name" item-value="value"></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="modal-footer--sticky">
            <v-spacer></v-spacer>
            <v-btn color="light" flat @click="closeEditRules()">Close</v-btn>
            <v-btn color="primary" :disabled="!editvalid" @click="saveEditRules()">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-navigation-drawer fixed disable-resize-watcher right v-model="page.isFilterOpen">
      <v-toolbar small color="secondary" style="color: white">
        <v-toolbar-title>Filter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="white" @click="page.isFilterOpen = false">
          <i class="fas fa-close"></i>
        </v-btn>
      </v-toolbar>
      <div class="flex-column justify-sb height-100-exclude-toolbar overflow-auto">
        <v-container class="sidenavContainer">
          <div class="autocompleteDiv">

            <v-autocomplete v-model="filter.payload.rule_name" :items="filtervalue" :loading="filter.isLoading"
              :search-input.sync="filter.search" label="Name"></v-autocomplete>
            <v-select :items="status" label="Status"
              v-model="filter.payload.active" item-text="name" item-value="value"></v-select>
          </div>
        </v-container>
        <v-container row class="sidenavFooter">
          <v-btn flat @click="reset()">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="getDataFromApi('filter')">Filter</v-btn>
        </v-container>
      </div>
    </v-navigation-drawer>
    <v-snackbar v-model="snackbar.show" :bottom="true" :right="true" :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn color="pink" flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="isProcessing" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import loader from "@/components/Widgets/loader";

export default {
  components: {
    loader,
  },

  data() {
    return {
      valid: true,
      editvalid: true,
      description: "",
      name: "",
      styleObject: {
        height: "80px",
        "margin-top": "-8px",
      },
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      dates: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      selecteddates: [],
      selectedMonths: [], // Array to store selected months
      selectedweek: [],
      showfrom_timePicker: false,
      showto_timePicker: false,
      showfrom_timePickeredit: false,
      showto_timePickeredit: false,
      showfrom_timePickerpreviousdata: "",
      showto_timePickerpreviousdata: "",

      page: {
        title: "Time rule",
        icon: "fa-clock-o fa-2x",
        loading: false,
        isAddtimerule: false,
        isFilterOpen: false,
        playingRecord: false,
        breadcrumbs: [],
        exportOptions: [],
        options: { filter: true, refresh: true, autoCompletePC: true },
        addnew: [],
        isEdittimerule: false,
        temp: { key: "addtimerule", label: "Add timerule" },
        candelete: false,
        timeModal: false,
        timeModal1: false,
        canedit: false,
      },
      pagecount: 0,
      headers: [
        {
          text: "Time rule",
          align: "left",
          class: "p0",
          sortable: false,
          value: "rule_name",
        },
        {
          text: "Description",
          align: "left",
          class: "p0",
          sortable: false,
          value: "description",
        },
        {
          text: "Status",
          align: "left",
          class: "p0",
          sortable: false,
          value: "active",
        },


        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "btn",
          // width: "20%",
        },
      ],
      timeruleData: [],
      //pagecount: 0,
      pagination: {
        rowsPerPage: 10,
      },
      snackbar: {
        show: false,
        timeout: 6000,
        text: "",
      },
      DeleteRowdata: false,
      showRowData: false,
      DataRow: false,
      tableLoading: false,
      crmdomain: "",
      filtervalue: [],
      // newArray: [],
      filter: {
        payload: {
          rule_name: "",
          active: "",
        },
       
        isLoading: false,
        search: "",
      },
      // pagination: {
      // page: 0,
      // rowsPerPage: 5
      // },
      isProcessing: false,
      call_status: [],
      edittimerule: {
        from_time: '00:00',
        to_time: '23:59',
        rule_name: "",
        description: "",
        active: "Y",

      },
      addtimerule: {

        payload: {
          from_time: '00:00',
          to_time: '23:59',
          rule_name: "",
          description: "",
          active: "Y",

        },

      },
     
      status: [{ value: 'Y', name: 'Active' }, { value: 'N', name: 'Inactive' }],
      deletemsg: '',
      deleted_data: {}
    };
  },
  methods: {
    opendateto:function(data,action){
     
      this.showto_timePickerpreviousdata= data
      if(action==="create"){
        this.showto_timePicker = true
      }else{
        this.showto_timePickeredit=true
      }
   
  },
    
  opendatefrom:function(data,action){
    this.showfrom_timePickerpreviousdata= data
    
    if(action==="create"){
      this.showfrom_timePicker = true
      }else{
        this.showfrom_timePickeredit=true
      }
  },
    refreshThisPage: function () {
      var scope = this;
      scope.page.loading = true;
      scope.pagination.page = 1;
      scope.filter.payload.rule_name = "";
      scope.filter.payload.active = "";
      scope.getDataFromApi();
    },
    toggleMonthSelection(month) {
      // Check if the month is already selected
      const index = this.selectedMonths.indexOf(month);

      if (index !== -1) {
        // If month is selected, remove it
        this.selectedMonths.splice(index, 1);
      } else {
        // If month is not selected, add it
        this.selectedMonths.push(month);
      }
    },
    handleClick(days, validate) {
      if (validate === false) {
        this.toggleDaysSelection(days);
      }


    },
    toMinutes(time) {
      if (!time) return 0; // Return 0 if no time is set
      const [hours, minutes] = time.split(':');
      return (parseInt(hours) * 60) + parseInt(minutes);
    },

    // Get minimum time for 'To Time' (must be strictly after 'From Time')
    getMinTime(from_time) {
      const fromMinutes = this.toMinutes(from_time);
      // Ensure that 'To Time' is strictly greater than 'From Time'
      let hours = Math.floor(fromMinutes / 60);
      let minutes = fromMinutes % 60;

      // Add one minute to 'From Time' to ensure 'To Time' is strictly greater
      minutes += 1;
      if (minutes >= 60) {
        minutes = 0;
        hours += 1;
      }

      // Format the time properly in hh:mm format
      return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    },
    toggleDaysSelection(days) {
      // Check if the month is already selected
      const index = this.selectedweek.indexOf(days);

      if (index !== -1) {
        // If month is selected, remove it
        this.selectedweek.splice(index, 1);
      } else {
        // If month is not selected, add it
        this.selectedweek.push(days);
      }
    },
    toggleDatesSelection(date, validate) {
      if (validate === false) {
        if (this.selecteddates.includes(date)) {
          this.selecteddates = this.selecteddates.filter(d => d !== date);
        } else {
          this.selecteddates.push(date);
        }
      }

    },
    closefrom_timePicker(action,type) {
      
      if(action==="close" && type==="add"){
        this.addtimerule.payload.from_time = this.showfrom_timePickerpreviousdata
        this.showfrom_timePickeredit =false
      this.showfrom_timePicker = false;
      }else if(action==="close" && type==="edit"){
        this.edittimerule.from_time=this.showfrom_timePickerpreviousdata
        this.showfrom_timePickeredit =false
      this.showfrom_timePicker = false;
      }else if(action==="ok" && type==="add"){
        if(this.addtimerule.payload.from_time>this.addtimerule.payload.to_time){
          // this.addtimerule.payload.from_time = this.showfrom_timePickerpreviousdata
          this.showSnackBar(`From time ${this.addtimerule.payload.from_time} need to be smaller than To time ${this.addtimerule.payload.to_time}`);
          this.showfrom_timePicker = true;
          this.showfrom_timePickeredit =false
        }else if(this.addtimerule.payload.from_time===this.addtimerule.payload.to_time){
          this.showSnackBar("From time To time can't be equal");
          this.showfrom_timePicker = true;
          this.showfrom_timePickeredit =false
        }
        else{
          this.showfrom_timePickeredit =false
      this.showfrom_timePicker = false;
        }
      }else if(action==="ok" && type==="edit"){
        if(this.edittimerule.from_time>this.edittimerule.to_time){
          // this.edittimerule.from_time=this.showfrom_timePickerpreviousdata
          this.showSnackBar(`From time ${this.edittimerule.from_time} need to be smaller than To time ${this.edittimerule.to_time}`);
          this.showfrom_timePicker = false;
          this.showfrom_timePickeredit =true
        }else if(this.edittimerule.from_time===this.edittimerule.to_time){
          this.showSnackBar("From time To time can't be equal");
           this.showfrom_timePicker = false;
          this.showfrom_timePickeredit =true
        }
        else{
          this.showfrom_timePickeredit =false
      this.showfrom_timePicker = false;
        }
      }
      
    },
    closeto_timePicker(action,type) {
      if(action==="close" && type==="add"){
        this.addtimerule.payload.to_time = this.showto_timePickerpreviousdata
        this.showto_timePicker = false;
        this.showto_timePickeredit =false
      }else if(action==="close" && type==="edit"){
        this.edittimerule.to_time=this.showto_timePickerpreviousdata
        this.showto_timePicker = false;
        this.showto_timePickeredit =false
      }else if(action==="ok" && type==="add"){
        if( this.addtimerule.payload.to_time===this.addtimerule.payload.from_time){
          this.showSnackBar("From time To time can't be equal");
          this.showto_timePicker = true;
          this.showto_timePickeredit =false
        }else{
          this.showto_timePicker = false;
        this.showto_timePickeredit =false
        }
      }else if(action==="ok" && type==="edit"){
         if( this.edittimerule.to_time===this.edittimerule.from_time){
          this.showSnackBar("From time To time can't be equal");
          this.showto_timePicker = false;
        this.showto_timePickeredit =true
        }else{
          this.showto_timePicker = false;
        this.showto_timePickeredit =false
        }
      }
     
    },


    filterClick: function () {
      this.page.isFilterOpen = true;
      this.filterFieldOptions();
    },

    reset() {
      var scope = this;
      scope.filter.payload.rule_name = "";
      scope.filter.payload.active = "";
      scope.getDataFromApi();
      this.page.isFilterOpen = true;
    },
    commonSearch(val) {
      try {
        if (val === null) {
          val = "";
        }
        if (this.page.isFilterOpen && val != null) {
          let scope = this;
          let selectedValue
          let defaultValue
          let data = {
            model: "Time_rules",
            column: ["rule_name"]
            , search: val
          };

          if (this.filtervalue.includes(val)) {
            defaultValue = val;

          }
          if (this.filter.payload.rule_name.trim().length >= 0) {
            selectedValue = this.filter.payload.rule_name;

          }

          // if (this.teams.length > 0) {
          //   data.team = this.teams.map(elm => elm.rule_name)
          //   console.log("4444444444444444444");

          // }
          this.$store
            .dispatch("GetModuleNameList", data)
            .then((response) => {
              scope.tableLoading = false;
              scope.page.loading = false;
              var datas = response.data;
              this.filtervalue = [...this.filtervalue,...datas[0].rule_name];
              if (selectedValue) {
                this.filtervalue.unshift( selectedValue);
              }
              if (defaultValue) {
                this.filtervalue.unshift( defaultValue);
                
              }
              this.filtervalue = [...new Set( this.filtervalue)];


            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (error) {
        console.log(error)
      }
    },
    filterFieldOptions() {
      this.commonSearch("")
    },
    getDataFromApi(action) {

      var scope = this;
      if (action !== undefined) {
        scope.pagination.page = 1;
      }
      scope.tableLoading = true;
      this.page.isFilterOpen = false;
      let take = this.pagination.rowsPerPage;
      let skip;
      if (this.pagination.page === 1) {
        skip = 0;
      } else {
        skip = this.pagination.rowsPerPage * (this.pagination.page - 1);
      }
      // let query = {
      // skip: skip,
      // take: take
      // }
      scope.filter.payload["skip"] = skip;
      scope.filter.payload["take"] = take;
      scope.skip = skip;
      this.$store
        .dispatch("GettimeRule", scope.filter.payload)
        .then((response) => {

          if (response.status === 204) {
            this.pagecount = 0;
            scope.tableLoading = false;
            scope.page.loading = false;
            scope.timeruleData = [];
            scope.filterFieldOptions();
          } else {
            this.pagecount = response.data.count;
            scope.tableLoading = false;
            scope.page.loading = false;
            var datas = response.data.data;

            scope.timeruleData = datas;
            scope.filterFieldOptions();
          }
        })
        .catch(function (error) {
          scope.page.isAddtimerule = false;
          scope.page.isEdittimerule = false;
          scope.showSnackBar(error);

        });
    },
    AddNewRule: function () {
      this.$refs.Timeerule.reset();
      this.resetfieldvalue("create")
     
      this.page.isAddtimerule = true;
    },
    sidebar_enable_disable(data) {
      this.$root.$emit('sidebar_disable', data);
    },
    closeEditRules: function () {
      this.page.isEdittimerule = false;
      this.$refs.Timeeruleupdate.reset();
    
    },
    closeAddtimerule: function () {
      
      
      this.page.isAddtimerule = false;
      
    },
    saveEditRules() {
      var scope = this;
      let payload = { ...this.edittimerule }
      payload.week = this.selectedweek.toString()
      payload.month = this.selectedMonths.toString()
      payload.day = this.selecteddates.toString()
      scope.$store
        .dispatch("UpdatatimeRule", payload)
        .then((res) => {
          if(res.status === 200 &&res.data.statusCode === 200){
          this.getDataFromApi();
          this.page.isEdittimerule = false;
          scope.page.isAddtimerule = false;
          scope.showSnackBar("Updated Successfully");
          this.$refs.Timeeruleupdate.reset();
          }else  if(res.status === 200 &&res.data.statusCode === 400){
            scope.showSnackBar(res.data.message);
          }
       
        })
        .catch(function (err) {
          if(err.message==="Request failed with status code 400"){
scope.showSnackBar("Time rule already mapped in call flow so can't able to inactive"
)
}else{
  scope.showSnackBar("Error! Unable to edit time rule");
}
        });

    },
    resetfieldvalue(type) {
      if (type === 'create') {

        this.addtimerule = {

          payload: {
            from_time: '00:00',
            to_time: '23:59',
            rule_name: "",
            description: "",
            active: 'Y',

          },

        }
      } else {
        this.edittimerule = {
          from_time: '00:00',
          to_time: '23:59',
          rule_name: "",
          description: "",
          active: "Y",

        }

      }
      this.selecteddates = []
      this.selectedMonths = []
      this.selectedweek = []
    },
    saveAddtimerule() {
      let payload = { ...this.addtimerule.payload }
      payload.week = this.selectedweek.toString()
      payload.month = this.selectedMonths.toString()
      payload.day = this.selecteddates.toString()
      var scope = this;
      scope.$store

        .dispatch("CreatetimeRule", payload)
        .then((res) => {
          if (res.data.statusCode === 201) {
            this.reset()
            scope.page.isAddtimerule = false;
            this.$refs.Timeerule.reset();
            scope.showSnackBar("Created Successfully");
            this.getDataFromApi();


          } else {
            this.page.isAddtimerule = false;
            this.$refs.Timeerule.reset();
            scope.showSnackBar("Error:" + res.data.message);
            this.getDataFromApi();
          }
          this.resetfieldvalue("create")
        })
        .catch((error) => {

          this.showSnackBar("error" + error);
        });
    },
    showSnackBar(message) {
      let scope = this;
      scope.snackbar.text = message;
      scope.snackbar.show = true;
      setTimeout(() => {
        scope.snackbar.show = false;
        scope.snackbar.text = "";
      }, scope.snackbar.timeout);
    },
    deleteItem(data) {
      this.delete_id = data.id;
      let scope = this

      scope.deletemsg = `Are you sure to delete this Time rule?`
      scope.deleted_data = data

      this.DeleteRowdata = true;
    },
    editItem(item) {
      //var scope = this;
      
      // this.editvalid = true
    
      this.selecteddates = (item.day === null || item.day) === "" ? [] : item.day.split(",")
      this.selectedMonths = (item.month === null || item.month) === "" ? [] : item.month.split(",")
      this.selectedweek = (item.week === null || item.week) === "" ? [] : item.week.split(",")

      this.edittimerule.id = item.id;
      this.edittimerule.active = item.active;
      this.edittimerule.rule_name = item.rule_name;
      this.edittimerule.description = item.description;
      this.edittimerule.from_time = item.from_time;
      this.edittimerule.to_time = item.to_time;
      console.log(item, "kkkkkkkdfdfkkkkkkkkkkk",this.edittimerule)
      this.page.isEdittimerule = true;



    },
    savedelete() {
      let scope = this;
      scope.isProcessing = true;
      scope.filtervalue = [];
      this.$store
        .dispatch("deletetimeRule", this.delete_id)
        .then((response) => {
          scope.isProcessing = false;
          if (response.data.message == "success") {
            scope.getDataFromApi();
            this.filterFieldOptions();
            scope.showSnackBar("Time rule Deleted");
           
          } else {
            console.log("jjjjjjjdvdfvjjjjjjjjjjj")
            scope.showSnackBar("Error! Unable Delete list");
          }
        })
        .catch((err) => {
          scope.isProcessing = false;
if(err.message==="Request failed with status code 400"){
scope.showSnackBar("Time rule already mapped in call flow so can't able to delete"
)
}else{
  scope.showSnackBar("Error! Unable to Delete time rule");
}
          
        });
      this.closedelete();
    },
    closedelete() {
      this.DeleteRowdata = false;
    },
    closeShow() {
      this.showRowData = false;
    },
  },

  mounted() {
    let scope = this;
    scope.sidebar_enable_disable(false)
    this.page.loading = false;
    setTimeout(
      function () {
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:timerule:create"
          ) !== -1
        ) {
          scope.page.addnew = [{ label: "Add Time Rule" }];
        }
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:timerule:edit"
          ) !== -1
        ) {
          scope.page.canedit = true;
        }
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:timerule:delete"
          ) !== -1
        ) {
          scope.page.candelete = true;
        }
      }.bind(scope),
      1
    );
    const project_config = JSON.parse(localStorage.projectConfig);
    this.crmdomain = project_config.projects[0].config[0].crm_domain;
    this.getDataFromApi();
    this.filterFieldOptions();
  },
  watch: {
    pagination: {
      handler() {
        if (this.pagination.page > 1 || this.skip >= 10) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
    "filter.search"(val) {
      this.commonSearch(val);
    },
    "page.isAddtimerule"(data) {
      this.sidebar_enable_disable(data);
    },
    "page.isEdittimerule"(data) {
      this.sidebar_enable_disable(data);
    }
  },
};
</script>
<style>
.mr-4 {
  text-align: start;
}

.file-dummy {
  width: 100%;
  padding: 30px;
  border: 2px dashed;
  text-align: center;
  transition: #2196f333 0.3s ease-in-out;
  cursor: pointer;
  font-weight: bold;
}

.highlighted {
  background-color: #BEE2FF !important;
  /* Change this to your preferred color */
  color: #fff;
  cursor: pointer;
}

.circle-btn {
  margin-left: 20px;
  color: #2196F3;
  border: 1px solid #2196F3;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  padding: 6px;
  font-size: 14px;
  line-height: 50px;
  cursor: pointer;
}

.dates {
  color: rgb(33, 150, 243);
  border: 1px solid;
  width: 30px;
  height: 30px;
  display: flex;
  border-radius: 50%;
  /* padding: 3px; */
  padding-top: 3px;
  padding-left: 5px;
  line-height: 36px;
}

.date-btn {
  width: 30px;
  height: 30px;
  margin-left: 8px;
  line-height: 30px;
  color: #2196F3;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  padding-left: 5px;
  margin-top: 10px;

}

.highlighteddates {
  border: 1px solid #2196F3;

  border-radius: 50%;
  cursor: pointer;
  background-color: #2196F3;

  color: white;

}

.blue-background {
  background-color: #2196F3;

}

.disabled-btn {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>